var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import ExcelJS from 'exceljs';
import { Tooltip } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import { searchProjects } from '../../services/projectService';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
import { useSelector } from "react-redux";
const ProjectExcelDownload = ({ filename, searchPrjRequest }) => {
    let lstEEMasters = [];
    const [loading, setLoading] = useState(false);
    const applicationData = useSelector((state) => state.applicationData);
    const downloadExcel = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        setLoading(true);
        searchPrjRequest.intFirstPage = null;
        searchPrjRequest.intPageSize = null;
        searchPrjRequest.boolCardView = false;
        lstEEMasters = yield searchProjects(searchPrjRequest);
        setLoading(false);
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Results');
        // Define columns
        worksheet.columns = [
            { header: 'Entity Name', key: 'entityName', width: 25 },
            { header: 'Project No', key: 'projectNo', width: 20 },
            { header: 'Project Type', key: 'projectType', width: 20 },
            { header: 'Project Status', key: 'projectStatus', width: 25 },
            { header: 'Risk Status', key: 'riskStatus', width: 20 },
            { header: 'Product Name', key: 'productName', width: 25 },
            { header: 'Brand/OEM', key: 'brandOem', width: 25 },
            { header: 'Product Model', key: 'productModel', width: 30 },
            { header: 'Recommended Start Date', key: 'startDate', width: 25 },
            { header: 'Deadline', key: 'deadline', width: 25 },
            { header: 'Actual Completion Date', key: 'completionDate', width: 25 },
            { header: 'BV Location', key: 'bvLocation', width: 25 },
        ];
        // Add rows
        if (Array.isArray(lstEEMasters)) {
            lstEEMasters.forEach(item => {
                var _a, _b, _c, _d, _e, _f;
                let familyItemsCount = ((_a = item.lstProductFamily) === null || _a === void 0 ? void 0 : _a.length) || 0;
                // Add the main row
                const row = worksheet.addRow({
                    entityName: ((_c = (_b = item.objClientMaster) === null || _b === void 0 ? void 0 : _b.objLuCompany) === null || _c === void 0 ? void 0 : _c.strLongDesc) || '',
                    projectNo: item.strProjectId || '',
                    projectType: item.strNewOrRenewal || '',
                    projectStatus: ((_d = item.objProjectStatus) === null || _d === void 0 ? void 0 : _d.strLongDesc) || '',
                    riskStatus: item.riskStatusId === 1 ? 'Project on Schedule' : 'Project on Risk',
                    productName: item.strProductNameEN || '',
                    brandOem: ((_e = item.objBrandName) === null || _e === void 0 ? void 0 : _e.strLongDesc) || '',
                    productModel: item.strPrimaryModel || '',
                    startDate: item.strdtProjPlannedStartDate || '',
                    deadline: item.strdtProjEstCompetionDate || '',
                    completionDate: item.strdtProjDueDate || '',
                    bvLocation: ((_f = item.objBusinessUnit) === null || _f === void 0 ? void 0 : _f.strBusinessUnitName) || '',
                });
                // Add rows for each product family
                if (Array.isArray(item.lstProductFamily)) {
                    item.lstProductFamily.forEach((familyItem, index) => {
                        var _a;
                        const familyRow = worksheet.addRow({
                            brandOem: ((_a = familyItem.objBrandName) === null || _a === void 0 ? void 0 : _a.strLongDesc) || '',
                            productModel: familyItem.strSeriesModel || '',
                        });
                        // Merge the first two columns for the first family row
                        if (index === 0) {
                            worksheet.mergeCells(row.number, 7, row.number, 7); // Brand/OEM
                            worksheet.mergeCells(row.number, 8, row.number, 8); // Product Model
                        }
                        worksheet.mergeCells(familyRow.number, 7, familyRow.number, 7); // Brand/OEM and Product Model
                        worksheet.mergeCells(familyRow.number, 8, familyRow.number, 8);
                    });
                }
                else {
                }
                if (familyItemsCount > 0) {
                    // Merge cells for columns that should span multiple rows
                    let rownumber = row.number;
                    familyItemsCount = familyItemsCount + 1;
                    worksheet.mergeCells(rownumber, 1, rownumber + familyItemsCount - 1, 1); // Entity Name
                    worksheet.mergeCells(rownumber, 2, rownumber + familyItemsCount - 1, 2); // Project No
                    worksheet.mergeCells(rownumber, 3, rownumber + familyItemsCount - 1, 3); // Project Type
                    worksheet.mergeCells(rownumber, 4, rownumber + familyItemsCount - 1, 4); // Project Status
                    worksheet.mergeCells(rownumber, 5, rownumber + familyItemsCount - 1, 5); // Risk Status
                    worksheet.mergeCells(rownumber, 6, rownumber + familyItemsCount - 1, 6); // Product Name
                    worksheet.mergeCells(rownumber, 9, rownumber + familyItemsCount - 1, 9); // Recommended Start Date
                    worksheet.mergeCells(rownumber, 10, rownumber + familyItemsCount - 1, 10); // Deadline
                    worksheet.mergeCells(rownumber, 11, rownumber + familyItemsCount - 1, 11); // Actual Completion Date
                    worksheet.mergeCells(rownumber, 12, rownumber + familyItemsCount - 1, 12); // BV Location        
                }
            });
        }
        commonService
            .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__ProjectMgmt_Report_Download);
        // Apply header styling
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'D3D3D3' },
        };
        worksheet.getRow(1).alignment = { horizontal: 'center' };
        // Convert to buffer and trigger download
        const buffer = yield workbook.xlsx.writeBuffer();
        const url = window.URL.createObjectURL(new Blob([buffer]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
    });
    return (_jsx(Tooltip, { color: "#00A4A4", title: 'Download Excel', children: _jsx(FileExcelOutlined, { style: { fontSize: '20px', color: 'green' }, onClick: downloadExcel, spin: loading }) }));
};
export default ProjectExcelDownload;
